import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

export default function AuthCallback({ setToken }) {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get("token");

    if (token) {
      localStorage.setItem("jwtToken", token);
      setToken(token);
      navigate("/"); // Send brukeren til startsiden eller dashboard
    }
  }, [location, navigate, setToken]);

  return <div>Laster inn...</div>;
}
